module.exports = __webpack_public_path__ + "img/soft-grove-study-3.1e23fbce.jpeg";